import PropTypes from "prop-types";
import WebIcon from "@/components/common/Web_Icons";
import { formatRelativeTimestamp } from "@/utils/supportUtils";

const SupportChatMessage = ({ message, timestamp, isAdmin, showSeen }) => {
  return (
    <div
      className={`flex flex-col w-full ${isAdmin ? "items-end" : "items-start"}`}>
      <div
        className={`max-w-[80%] p-3 rounded-lg ${
          isAdmin ? "bg-primary text-white" : "bg-secondary text-black"
        }`}>
        <p className="text-regular">{message}</p>
      </div>
      <div
        className={`w-[80%] mt-1 flex items-center gap-2 ${
          isAdmin ? "justify-end" : ""
        }`}>
        <WebIcon icon="Clock" className="w-4 h-4 text-lighterGrey" />
        <span className="text-small text-lighterGrey">
          {formatRelativeTimestamp(timestamp) || timestamp}
        </span>
        {isAdmin && showSeen && (
          <div className="flex items-center gap-1 ml-2">
            <div className="flex items-center justify-center w-4 h-4 rounded-full bg-primary">
              <svg
                width="10"
                height="8"
                viewBox="0 0 10 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M1 4L3.5 6.5L9 1"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <span className="text-small text-lighterGrey">Seen</span>
          </div>
        )}
      </div>
    </div>
  );
};

SupportChatMessage.propTypes = {
  message: PropTypes.string,
  timestamp: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isAdmin: PropTypes.bool,
  showSeen: PropTypes.bool,
};

export default SupportChatMessage;
